module.exports = __webpack_public_path__ + "static/CTO_Partners_group-fe608c2ff01c14a879efd53dd7c3aa30.png";